import { render, staticRenderFns } from "./Sluzby.vue?vue&type=template&id=4ebe020c&scoped=true&"
import script from "./Sluzby.vue?vue&type=script&lang=js&"
export * from "./Sluzby.vue?vue&type=script&lang=js&"
import style0 from "./Sluzby.vue?vue&type=style&index=0&id=4ebe020c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe020c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ebe020c')) {
      api.createRecord('4ebe020c', component.options)
    } else {
      api.reload('4ebe020c', component.options)
    }
    module.hot.accept("./Sluzby.vue?vue&type=template&id=4ebe020c&scoped=true&", function () {
      api.rerender('4ebe020c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Sluzby.vue"
export default component.exports